


import './App.css';
import Navbar from './Components/Navbar';
import { Routes, Route } from'react-router-dom'
import { useEffect, useRef } from 'react';
import Home from './Pages/Home'
import About from './Pages/About'
import Contact from './Pages/Contact'
import Work from './Pages/Work'
import Footer from './Components/Footer';

import Sound from '../src/Assets/bg.mp3';


import Lenis from '@studio-freight/lenis';
import Cursor from './Components/Cursor';



function App() {

  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.loop = true; 
      audioRef.current.autoplay = true; 
      audioRef.current.volume = 0.5; 
    }
  }, []);


  const lenisRef = useRef();
  useEffect(() => { 
    const lenis = new Lenis({
      duration: 1.2, 
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
      direction: 'vertical',
      gestureDirection: 'vertical', 
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: true,
      touchMultiplier: 2,
      infinite: false,
      lerp: 0.03,
      wheelMultiplier: 1,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    lenisRef.current = lenis; 

    return () => {
      lenis.destroy(); 
    };
  }, []);


  
  return (
    
  <div className="scroll-container bg-zinc-900 overflow-x-hidden scroller">

  
   
  <Navbar/>
 
  <Routes> 
    <Route exact path="/" element={<Home/>}/>
    <Route path="/about" element={<About/>} />
    <Route path="/contact" element={<Contact/>} />
    <Route path="/work" element={<Work/>} />
  </Routes> 
   <audio ref={audioRef} src={Sound}  preload="auto">
          <source src={Sound} type="audio/mpeg" />
        </audio>
  <Footer/>
  </div>
  );
}

export default App;
